// Opciones de reconocimiento/acreditación
export const RECONOCIMIENTO_OPTIONS = [
  { id: 'titulo_propio', label: 'Título propio' },
  { id: 'eves', label: 'Reconocido por EVES' },
  { id: 'cfc', label: 'Con CFC' },
  { id: 'semes', label: 'SEMES' },
  { id: 'erc', label: 'ERC' },
  { id: 'semicyuc', label: 'SEMICYUC' },
  { id: 'otros', label: 'Otros' }
];

// Estado inicial del formulario
export const INITIAL_FORM_STATE = {
  nombre: '',
  descripcion: '',
  horas: '',
  numero_sesiones: '',
  sesiones: [],
  objetivos_generales: '',
  objetivos_especificos: '',
  temario: '',
  instructor_ids: [],
  director_formacion_id: '',
  cliente: '',
  lugar_imparticion: '',
  localidad: '',
  provincia: '',
  familia: '',
  subfamilia: '',
  template_id: '',
  online_course_id: '',
  reconocimiento: [],
  reconocimiento_otros: '',
  acreditacion_cfc: '',
  acreditacion_erc: '',
  acreditacion_semes: '',
  acreditacion_semicyuc: '',
  coste_total: '',
  coste_por_alumno: '',
  // Configuración de certificados
  tipo_certificado: 'propio',
  modalidad: 'presencial',
  creditos_cfc: '',
  numero_acreditacion_cfc: '',
  texto_certificado_manual: '',
  firma_director_url: '',
  // Videoconferencia
  meet_link: ''
};
